import 'reflect-metadata';
import { container } from 'tsyringe';
import { GetDaysDifference } from './getDaysDifference';
import { GetExchangeRates } from './getExchangeRates';
import { RatingConverter } from './ratingConverter';
import { GetClientIp } from './getClientIp';
import { ValidateDateLocation } from './validateDateLocation';
import { TrackHelper } from './trackHelper';
import { GenerateSearchId } from './generateSearchId';
import { GenerateSessionId } from './generateSessionId';
export const DependencyInjectionUtilsInfrastructure = () => {
    container.register("iGetDaysDifference", { useClass: GetDaysDifference });
    container.register("iGetExchangeRates", { useClass: GetExchangeRates });
    container.register("iRatingConverter", { useClass: RatingConverter });
    container.register("iGetClientIp", { useClass: GetClientIp });
    container.register("iValidateDateLocation", { useClass: ValidateDateLocation });
    container.register("iTrackHelper", { useClass: TrackHelper });
    container.register("IGenerateSearchId", { useClass: GenerateSearchId });
    container.register("IGenerateSessionId", { useClass: GenerateSessionId });
};
export default DependencyInjectionUtilsInfrastructure;
